import gql from 'graphql-tag';

export const createLeaderboard = gql`
  mutation createLeaderboard($input: InputLeaderboard) {
    createLeaderboard(input: $input) {
      id
      name
      periodFrom
      periodTo
      active
    }
  }
`;
